import { isDevelopment } from '@env';
import { loadFontsData } from './fontsData';
import { loadCanvasKit } from './loadCanvasKit';
import { loadResvg } from './loadResvg';
import { resourcesState } from './resourcesLoaded.svelte';

export async function loadResources(): Promise<void> {
  await loadFontsData(['fonts']);

  const canvasKitPrefix = isDevelopment() ? ['canvaskit'] : []; // Assumes canvaskit.wasm is in the dist directory in production

  await loadCanvasKit(canvasKitPrefix);

  // Load resvg WASM for SVG rendering — keep under /resvg in both envs
  // Your bucket already has s3://cadet.cc/resvg/index_bg.wasm
  const resvgPrefix = ['resvg'];
  await loadResvg(resvgPrefix, undefined, undefined);

  performance.mark('resourcesLoaded');
  resourcesState.resourcesLoaded = true;
}
